(function($) {

    // evenly space smaller circles around industries container 
    elementCircle = function() {
        i = 0
        b = 0

        var elementTarget = '.js-leader-circle';

        $(elementTarget).each(function() {
            var $this = $(this);
            var circleQty = $this.attr('data-circle-count');
            var circleCount = 360 / circleQty;
            var elementItem = $this.find('.circle-item');
            var circleHeight = $this.outerHeight();

            $this.addClass('leader-circle-' + circleQty);

            $(elementItem).each(function(n, e) {
                $this = $(this);
                $this.addClass('circle-item-' + circleQty)

                var elementHeight = $this.closest(elementTarget).outerHeight();
                var smallCircleHeight = elementHeight / 2;

                $this.css({
                    transform: 'rotate(' + i++ *circleCount + 'deg) translate(' + smallCircleHeight + 'px)',
                });
                $this.find('.circle-title').css({
                    transform: 'rotate(-' + b++ *circleCount + 'deg)',
                })
            });
        });

    };
    elementCircle();

    $(window).resize(function() {
        elementCircle();
    });

}(jQuery));
